import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Linear, TweenMax } from "gsap";
import SvgSuccessSpaceman from "../svg/SuccessSpaceman";
import FlipReset from "../../containers/FlipMatchReset/FlipMatchReset";
import FlipMatchProgress from "../FlipMatchProgress/FlipMatchProgress";
import { FLIP_MATCH_STATE_TYPE } from "../../containers/FlipMatch/constants";
import SvgSuccessStars from "../svg/SuccessStars";

function FlipMatchSuccessWrapper(props) {
    const [t] = useTranslation();
    return <FlipMatchSuccess {...props} t={t} />;
}

class FlipMatchSuccess extends React.Component {

    componentDidMount() {
        this.animatePlanets();
    }

    componentDidUpdate() {
        this.animatePlanets();
    }

    animatePlanets = () => {
        const planets = document.getElementsByClassName('success-planet');
        let negative = planets.length;
        for (let i = 0; i < planets.length; i++) {
            const pl = planets[i];
            TweenMax.fromTo(pl, 23, {
                left: `${Math.round(Math.random() * 100)}%`,
                top: -600 * (i + 1),
                scale: 8
            }, {
                top: 600 * (negative + 1),
                repeat: -1,
                repeatDelay: 1,
                ease: Linear.easeInOut
            })
            negative--;
        }
    }

    render() {
        const { flip } = this.props;
        return (
            <div className="success">
                <div>
                    <SvgSuccessStars className="success-stars" />
                    <FlipMatchProgress className="success-planets" itemClassName="d-flex flex-column success-planet" flip={flip} />
                    <SvgSuccessSpaceman className="success-spaceman" />
                    <div className="success-message">
                        <h2>{this.props.t("blast_off")}</h2>
                        <FlipReset className="btn btn-sm btn-primary"
                            confirm={this.props.t("reset_confirm")}>{this.props.t("plot_another_course")}</FlipReset>
                    </div>
                </div>
            </div>

        )
    }
}

FlipMatchSuccess.propTypes = {
    flip: FLIP_MATCH_STATE_TYPE,
    t: PropTypes.func.isRequired,
};

FlipMatchSuccess.defaultProps = {
    flip: {}
};

export default FlipMatchSuccessWrapper;